module.exports = __webpack_public_path__ + "img/card.65dcf1a7.jpg";